<template>
	<span v-if="$data.draftItem"> <!-- position: absolute; top: 20px; right: 20px; -->
		<modal :visible.sync="modalVisible_main" :wide="true" :big_height="false" :closeable="false">
			<div slot="header">
				<h3>По данной записи имеются несохраненные изменения</h3>
			</div>
			<div slot="body">
				<table class="table table-striped">
					<tbody>
						<tr>
							<td>Дата</td>
							<td>{{draftItem.dateCreate | prettyDate}}</td>
						</tr>
						<tr>
							<td>АРМ</td>
							<td>{{draftItem.armName}} [{{draftItem.armId}}]</td>
						</tr>
						<tr>
							<td>Сайт</td>
							<td>{{draftItem.siteName}} [{{draftItem.siteId}}]</td>
						</tr>
						<tr v-if="draftItem.recordName || draftItem.recordId">
							<td>Запись</td>
							<td>
								{{draftItem.recordName}}
								<template v-if="draftItem.recordId">[{{draftItem.recordId}}]</template>
							</td>
						</tr>
						<tr>
							<td>Действие</td>
							<td>
								<template v-if="draftItem.recordId === 0">Создание</template>
								<template v-else>Редактирование</template>
							</td>
						</tr>
						<tr>
							<td>Логин</td>
							<td>{{draftItem.userName}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div slot="footer" class="row">
				<div class="col-md-6">
					<a @click="draftView()" class="btn btn-default btn-block">Просмотреть</a>
				</div>
				<div class="col-md-6">
					<a @click="draftAccept($data.draftItem)" class="btn btn-primary btn-block">Принять изменения</a>
				</div>
				<div class="col-md-6">
					<a @click="draftRemove()" class="btn btn-danger btn-block">Удалить черновик</a>
				</div>
				<div class="col-md-6">
					<a @click="$emit('back_to_list')" class="btn btn-default btn-block">Вернуться в список</a>
				</div>
			</div>
		</modal>

		<modal :visible.sync="modalVisible_arm" :closeable="false">
			<div slot="body">
				<global-component-page-list :arm_id="77732" :predefined_filter="armPredefinedFilter"  :pick_type="'draft_pick_type'" /> <!-- p_list.vue, доступен глобально из корня приложения - uarm (entry-point.js) и wizard (main.js) -->
			</div>
			<div slot="footer" class="row">
				<div class="col-md-8">
					<a @click="draftAccept($data.draftItem)" class="btn btn-primary btn-block">Принять изменения</a>
				</div>
				<div class="col-md-8">
					<a @click="toggleModal(true, false)" class="btn btn-default btn-block">Вернуться</a>
				</div>
				<div class="col-md-8">
					<a @click="draftRemove()" class="btn btn-danger btn-block">Удалить</a>
				</div>
			</div>
		</modal>
	</span>
</template>

<script>
	import draftCommon from './draft-common.js'
	import dateUtil from '@uarmSrc/util-date.js'
	import modal from '@uarmSrc/modal.vue'

	export default {
		name: 'DraftSplashScreen',
		props: {
			draft_list: {
				type: Array,
				default: function() {
					return []
				},
			},
			record_id: {
				type: Number,
			},
			arm_id: {
				type: Number,
			},
			site_id: {
				type: Number,
			},
		},
		data() {
			// это черновик СУЩЕСТВУЮЩЕЙ записи, который пришёл с запросом её данных
			// рассчитываем что такой черновик будет всегда один, а в АПИ просто задел, мало ли
			var draftItem = this.$props.draft_list[0];

			// это черновик который был сохранён в сессию перед переходом по ссылке из колокольчика
			// для того чтобы немедленно после перехода быть применённым
			var $p = this.$props;
			var storedDraftToAccept = draftCommon.acceptance.getAndRemove($p.site_id, $p.arm_id, $p.record_id);

			if (draftCommon.intervalMemory.get() === 0) {
				draftItem = false;
			}

			var armPredefinedFilter = draftItem ? { // PIRS2018-3362
				_master_arm_id: draftItem.armId,
				draft_master_id: draftItem.id,
			} : undefined;

			return {
				modalVisible_main: !storedDraftToAccept && !!draftItem,
				modalVisible_arm: false,
				draftItem,
				armPredefinedFilter,
				storedDraftToAccept,
			}
		},
		components: {
			modal
		},
		methods: {
			toggleModal: function(mainModalBoolean, armModalBoolean) {
				this.$data.modalVisible_main = !!mainModalBoolean;
				this.$data.modalVisible_arm = !!armModalBoolean;
			},
			draftAccept: function(dr) {
				this.toggleModal(false, false);
				this.$emit('draft_accept', dr);
				draftCommon.doRemove(dr);
			},
			draftView: function() {
				this.toggleModal(false, true);
			},
			draftRemove: function() {
				this.toggleModal(false, false);
				draftCommon.doRemove(this.$data.draftItem)
			},
		},
		created: function() {
			if (this.$data.storedDraftToAccept) {
				draftCommon.log('draft-splash: применяем полученный из сессии черновик');
				this.draftAccept(this.$data.storedDraftToAccept);
			}
		},
		filters: {
			prettyDate: function(d) {
				return dateUtil.isoToHuman(d)
			},
		}
	}

</script>
